<m-message-page :state="state" :svg-name="svgName" :title="title" :hints="isMqMinS ? hintsDesktop : hintsMobile" :links="isMqMinS ? linksDesktop : linksMobile">
</m-message-page>
